import * as React from 'react'
import { SVGProps } from 'react'

const NEARUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' fill='white' />
    <g clipPath='url(#clip0_645_6554)'>
      <path
        d='M31.232 13.2231L26.2242 20.6549C25.8779 21.161 26.5438 21.7736 27.0233 21.3474L31.9512 17.0588C32.0843 16.9523 32.2708 17.0322 32.2708 17.2187V30.6171C32.2708 30.8036 32.0311 30.8835 31.9245 30.7503L17.0078 12.9035C16.5283 12.3174 15.8357 11.9978 15.0633 11.9978H14.5305C13.1454 11.9978 12 13.1432 12 14.555V33.414C12 34.8258 13.1454 35.9712 14.5572 35.9712C15.4362 35.9712 16.2619 35.5184 16.7414 34.7459L21.7492 27.3141C22.0954 26.808 21.4295 26.1954 20.9501 26.6216L16.0222 30.8835C15.889 30.99 15.7026 30.9101 15.7026 30.7237V17.3519C15.7026 17.1654 15.9423 17.0855 16.0488 17.2187L30.9656 35.0655C31.4451 35.6515 32.1643 35.9712 32.9101 35.9712H33.4428C34.8546 35.9712 36 34.8258 36 33.414V14.555C36 13.1432 34.8546 11.9978 33.4428 11.9978C32.5372 11.9978 31.7114 12.4506 31.232 13.2231Z'
        fill='black'
      />
    </g>
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' stroke='#D1D3E5' />
    <defs>
      <clipPath id='clip0_645_6554'>
        <rect width='24' height='23.9734' fill='white' transform='translate(12 11.9978)' />
      </clipPath>
    </defs>
  </svg>
)

export default NEARUSD
